import {useInfiniteQuery} from 'react-query';
import useInfiniteScroll from '../../../utilities/hooks/useInfiniteScroll';
import {getStoreAds} from '.';

const useGetStoreAds = (payload?: IStoreAdsProps) => {
  const {
    data: rawData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ['get-store-ads', payload],
    ({pageParam = 1}) => getStoreAds(pageParam, payload),
    {
      enabled: Boolean(payload),
      getNextPageParam: (lastPage, allPages) => {
        const next = lastPage?.next;
        if (!next) return undefined;

        return new URL(next).searchParams.get('page');
      },
    },
  );

  const data = rawData?.pages.flatMap(page => page.results) ?? [];

  const loaderRef = useInfiniteScroll({
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  return {
    data,
    isLoading,
    loaderRef,
    isFetchingNextPage,
  };
};

export default useGetStoreAds;
